import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-banker-group-modal-add-admin',
  templateUrl: './banker-group-modal-add-admin.component.html',
  styleUrls: ['./banker-group-modal-add-admin.component.scss']
})
export class BankerGroupModalAddAdminComponent {

  @ViewChild('f', { static: false }) f : NgForm;
  
  @Input() banker_group_uuid: string;
  public data: any = {is_banker: 1, is_banker_admin: 1, status: 1, is_banker_super_admin: 0};
  @Input() set setData(v:any) {
    if(v) {
      this.data = v;
    }
  }
  @Output() closeEvent = new EventEmitter<boolean>();

  constructor(private http: HttpService) { }

  async submit() { 

    if(this.f.invalid) {
      return;
    }

    this.data.banker_group_uuid = this.banker_group_uuid;
    let y:any = await this.http.post("/admin/banker-group/add-admin", this.data);
    if(y.status) {
      this.closeEvent.emit(true);

    }

    if(!y.status && y.message) {
      this.http.notify(y.message);
    }
  }

}
